import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { mergeAssetIntoPrefab } from './mergeAssetIntoPrefab';
import { mergePhotoIntoPrefab } from './mergePhotoIntoPrefab';
import { mergeTextIntoPrefab } from './mergeTextIntoPrefab';

export type Direction = 'inputIntoPrefab' | 'prefabIntoInput';

export const merge = (
    userInput: GiftJson.Input<any>,
    prefabInput: GiftJson.Input<any>,
    variable: GiftJson.Variable<any>,
    direction: Direction
): GiftJson.Input<any> => {
    if (variable.pluginId === 'text') {
        return mergeTextIntoPrefab(prefabInput, userInput, variable, direction);
    } else if (variable.pluginId === 'engraving' || variable.pluginId === 'svg') {
        return mergeAssetIntoPrefab(prefabInput, userInput);
    } else if (variable.pluginId === 'photo') {
        return mergePhotoIntoPrefab(prefabInput, userInput);
    } else {
        return prefabInput;
    }
};